import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";

import CheckIcon from "@mui/icons-material/Check";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Body from "../../layout/Body";
import SnackBarUI from "../../comman/SnackBarUI";
import { getAllAppAction } from "../../redux/toolkit/app/getAllApp";
import axios from "axios";

import { amountByAdminAction } from "../../redux/toolkit/users/amountByAdmin";
import { getUserAction } from "../../redux/toolkit/users/getAdminSupports";

const AmountByAdmin = ({ state, setState, userId }) => {
  //   const {
  //     register,
  //     setValue,
  //     setError,
  //     watch,
  //     handleSubmit,
  //     formState: { errors },
  //     reset,
  //   } = useForm({ resolver: yupResolver(partnerSchema) });

  const dispatch = useDispatch();
  const [snack, setSnack] = useState(false);
  const [app, setApp] = useState("");
  const [amount, setAmount] = useState(0);

  console.log("app", app);

  const appsData = useSelector((state) => state.appAllList);
  const { data: app_data, loading, status, message } = appsData;

  const amountAdmin = useSelector((state) => state.amountByAdmin);
  const {
    data: amount_data,
    loading: amount_loading,
    status: amount_status,
    message: amount_message,
  } = amountAdmin;

  const handleAmountByAdmin = async (e, value) => {
    e.preventDefault();

    if (app == "" || amount == 0 || amount < 0) {
    //   alert("Please fill all the fields");
      return;
    }

    setState(false);

    const res = await dispatch(
      amountByAdminAction({
        app_id: app,
        amount: amount,
        isCredit: value,
        userId: userId,
      })
    );

    setSnack(true);

    setTimeout(() => {
      setState(false);
      if (res?.payload?.status == 200) {
        dispatch(
          getUserAction({
            is_block: false,
          })
        );
      }
    }, 1000);
  };

  const handleClose = () => {
    setState(false);
  };

  const handleChange = (event) => {
    setApp(event.target.value);
  };

  useEffect(() => {
    dispatch(getAllAppAction({}));
  }, []);

  return (
    <>
      <Body>
        {/* <Modal sx={{ overflow: "scroll" }} open={state} onClose={handleClose}>
          <Box className="modal_box">
            <Card sx={{ width: 500, p: 5 }}>
              <Typography variant="h5" sx={{ mb: 5 }} align="center">
                Amount By Admin
              </Typography>

           
              <Box
                component="form"
                sx={{ height: "auto" }}
              >
                <Box sx={{ minWidth: 120, marginBottom: "20px" }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Select App
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={app?.app_name}
                      label="Select App"
                      onChange={handleChange}
                    >
                      {app_data?.map((item, i) => (
                        <MenuItem value={item?._id}>{item?.app_name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <Stack direction={"row"} spacing={2} sx={{ minWidth: "120px" }}>
                  <TextField
                    label="Amount"
                    InputLabelProps={{ shrink: true }}
                  
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Stack>

                <Stack direction="row" spacing={2} mt={3}>
                  <Button
                    sx={{ zIndex: 1000 }}
                    variant="contained"
                    type="submit"
                    disabled={loading}
                    onClick={() => {
                      handleAmountByAdmin(true);
                    }}
                  >
                    {loading ? <CircularProgress /> : "Credit"}
                  </Button>

                  <Button
                    sx={{ zIndex: 1000 }}
                    variant="contained"
                    type="submit"
                    disabled={loading}
                    onClick={() => {
                      handleAmountByAdmin(false);
                    }}
                  >
                    {loading ? <CircularProgress /> : "Debit"}
                  </Button>

                  
                </Stack>
              
              </Box>
            </Card>
          </Box>
        </Modal> */}

        <Modal sx={{ overflow: "scroll" }} open={state} onClose={handleClose}>
          <Box
            className="modal_box"
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
          >
            <Card sx={{ width: 500, p: 5 }}>
              <Typography variant="h5" sx={{ mb: 5 }} align="center">
                Amount By Admin
              </Typography>

              <Box component="form" sx={{ height: "auto" }}>
                {/* App Selector */}
                <Box sx={{ minWidth: 120, mb: 3 }}>
                  {/* <FormControl fullWidth>
                    <InputLabel id="select-app-label">Select App</InputLabel>
                    <Select
                      labelId="select-app-label"
                      id="select-app"
                      value={app?.app_name || ""}
                      label="Select App"
                      onChange={handleChange}
                    >
                      {app_data?.map((item) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.app_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}


                   <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Select App
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={app?.app_name}
                      label="Select App"
                      onChange={handleChange}
                    >
                      {app_data?.map((item, i) => (
                        <MenuItem value={item?._id}>{item?.app_name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* Amount Input */}
                <Stack direction="row" spacing={2}>
                  <TextField
                    fullWidth
                    label="Amount"
                    value={amount}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Stack>

                {/* Buttons */}
                <Stack direction="row" spacing={2} mt={3}>
                  <Button
                    variant="contained"
                    // disabled={loading}
                    onClick={(e) => handleAmountByAdmin( e , true)}
                  >
                    {loading ? <CircularProgress size={24} /> : "Credit"}
                  </Button>

                  <Button
                    variant="contained"
                    color="error"
                    // disabled={loading}
                    onClick={(e) => handleAmountByAdmin( e , false)}
                  >
                    {loading ? <CircularProgress size={24} /> : "Debit"}
                  </Button>
                </Stack>
              </Box>
            </Card>
          </Box>
        </Modal>

        {
         snack && <SnackBarUI
            state={snack}
            setState={setSnack}
            status={amount_status}
            message={amount_message}
          />
        }
      </Body>
    </>
  );
};

export default AmountByAdmin;
